import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import VolunteersActivities from 'src/containers/FdcMilanoLogbook/Charts/VolunteersActivities';

import './styles.scss';

const FdcMilanoLogbook = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const registerRecordSurvey = searchParams.get('register_record_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [registerRecordSubmissions, setRegisterRecordSubmissions] = useState([]);
    const [checkpoints, setCheckpoints] = useState([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: registerRecordSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            const responsesCheckpoints = await apiCall({
                url: `containers/${container}/checkpoints/all`,
            });

            setRegisterRecordSubmissions(responses.data.submissions);
            setCheckpoints(responsesCheckpoints.data.items);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={12}>
                                <VolunteersActivities
                                    registerRecordSubmissions={registerRecordSubmissions}
                                    checkpoints={checkpoints}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoLogbook;